export const AnalyticsEndpoints = {
  GET_CATALOG: '/api/admin/analytics/views',
  QUERY_VIEW: (view: string) => `/api/admin/analytics/views/${view}`,
  TRIGGER_PIPELINE: '/api/admin/analytics/pipeline/run',
  GET_RUN_STATUS: (runId: number) => `/api/admin/analytics/pipeline/runs/${runId}`,
  GET_PIPELINE_HEALTH: '/api/admin/analytics/pipeline/health',
};
